/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { Form, Formik } from "formik";
import React, { useContext, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import Pagination from "react-js-pagination";
import * as Yup from "yup";
import API from "../../API";
import { ShowContext } from "../../App";
import FormField from "../../utils/FormField";
import { uploadFileToS3UsingSignedURL } from "../../utils/Helper";

const Committees = () => {

    const myInitialValues = {
        parentId: "",
        name: "",
        org: "",
        designation: "",
        status: "",
        order_id: "",
    };

    const { setShow, setMsg } = useContext(ShowContext);

    const header = [
        { text: "Sr.No.", dataField: "srno" },
        { text: "Name", dataField: "name" },
        { text: "Organization (संस्था व पदनाम)", dataField: "org" },
        { text: "Designation (समिती मधील पद)", dataField: "designation" },
        { text: "Parent", dataField: "parentName" },
        { text: "Order ID", dataField: "order_id" },

        { text: "Modify", dataField: "edit" },
        { text: "Status", dataField: "status" },
    ];

    // const parents = ["PDF", "URL"];

    const validationSchema = Yup.object({
        name: Yup.string().required("Name is required"),
        parentId: Yup.mixed().required("Parent is required"),
    });

    const [list, setList] = useState();
    const [data, setData] = useState();
    const [parents, setParents] = useState([])

    const [editData, setEditData] = useState();

    const [curPage, setCurPage] = useState(0);
    const [perPage, setPerPage] = useState(0);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        if (list) {
            setCurPage(list.current_page);
            setPerPage(list.per_page);
            setTotal(list.total);

            getData(list.data);
        }
    }, [list]);

    useEffect(() => {
        getTableData(1);
    }, []);

    return (
        <div className="py-1">
            <div className="card">
                <div className="card-body">
                    <h3>
                        <center>Committees</center>
                    </h3>
                    <Formik
                        initialValues={editData ? editData : myInitialValues}
                        enableReinitialize={true}
                        validationSchema={validationSchema}
                        onSubmit={(values, { setSubmitting, resetForm }) => {
                            if (editData) {
                                updateData(values, setSubmitting, resetForm);
                            } else {
                                addData(values, setSubmitting, resetForm);
                            }
                        }}
                    >
                        {({ values, setFieldValue, isSubmitting, errors }) => (
                            <Form>
                                {Object.keys(errors).length > 0 && <div className="alert alert-danger">
                                    {Object.keys(errors).slice(0, 1).map((key) => (
                                        <div key={key}>{errors[key]}</div>
                                    ))}
                                </div>}
                                <div className="row">
                                    <div className="col-sm-6">
                                        <FormField name="name" heading="Name" />
                                    </div>
                                    <div className="col-sm-6">
                                        <FormField name="org" heading="Organization (संस्था व पदनाम)" />
                                    </div>
                                    <div className="col-sm-6">
                                        <FormField name="designation" heading="Designation (समिती मधील पद)" />
                                    </div>
                                    <div className="col-sm-6">
                                        <FormField
                                            values={values}
                                            name="parentId"
                                            heading="Select Parent"
                                            as="select"
                                            options={parents?.map((item, i) => (
                                                <option key={i} value={item.id}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        />
                                    </div>
                                    <div className="col-sm-6">
                                        <FormField name="order_id" heading="Order ID (Optional)" />
                                    </div>
                                </div>

                                <div className="text-center py-3">
                                    <button
                                        type="submit"
                                        className="btn btn-primary mx-2"
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <span
                                                    className="spinner-border spinner-border-sm me-2"
                                                    role="status"
                                                    aria-hidden="true"
                                                ></span>
                                                &nbsp;Submitting...
                                            </>
                                        ) : (
                                            "Submit"
                                        )}
                                    </button>
                                    {editData && (
                                        <button
                                            type="button"
                                            className="btn btn-danger mx-2"
                                            onClick={(e) => setEditData()}
                                            disabled={isSubmitting}
                                        >
                                            Cancel
                                        </button>
                                    )}
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
            <div className="card my-3">
                <div className="card-body">
                    <div className="m-3">
                        {data && data?.length > 0 && (
                            <BootstrapTable
                                data={data}
                                columns={header}
                                keyField="srno"
                                headerClasses="allTable_header text-center"
                            />
                        )}
                    </div>
                    {data && data?.length > 0 && <div
                        className="mt-1 d-flex justify-content-around">
                        <Pagination
                            totalItemsCount={total}
                            activePage={curPage}
                            itemsCountPerPage={perPage}
                            onChange={(pageNumber) => {
                                setCurPage(pageNumber);
                                getTableData(pageNumber);
                            }}
                            itemClass="page-item"
                            linkClass="page-link"
                            firstPageText="First"
                            lastPageText="Last"
                        />
                    </div>}
                </div>
            </div>
        </div>
    );

    function getData(params) {
        setData(
            params.map((item, i) => {
                return {
                    ...item,
                    srno: ((curPage - 1) * perPage) + i + 1,
                    org: item.org ?? "-",
                    designation: item.designation ?? "-",
                    parentName: item.parent?.name ?? "#",
                    edit: (
                        <button
                            className="btn btn-warning"
                            onClick={() => setEditData(item)}
                        >
                            Modify
                        </button>
                    ),
                    status: (
                        <label className="switch">
                            <input
                                type="checkbox"
                                checked={item.status}
                                onChange={() => {
                                    updateStatus(item.id, item.status ? 0 : 1);
                                }}
                            />
                            <span className="slider round"></span>
                        </label>
                    ),
                };
            })
        );
    }

    async function getTableData(page) {
        getParents()
        try {
            const res = await API.get("/committees", { params: { page } });
            setList(res.data?.data);
            // show({message: data.message, displayClass: data.status })
        } catch (error) {
            setShow(true);
            setMsg(error.response.data.message);
        }
    }

    async function getParents() {
        try {
            const res = await API.get("/committees/parents");
            let data = res.data?.data;
            data.unshift({ id: 0, name: "No Parent" });
            setParents(data);

            // show({message: data.message, displayClass: data.status })
        } catch (error) {
            setShow(true);
            setMsg(error.response.data.message);
        }
    }

    async function updateData(values, setSubmitting, resetForm) {
        try {
            if (values.pdfUrl instanceof File) {
                values.pdfUrl = await uploadFileToS3UsingSignedURL(values.pdfUrl, "menuPagesPDFs");
            }

            await API.put("/committees", values);
            // setList((pre) => ({
            //     ...pre,
            //     data: pre.data.map((rec) => {
            //         if (rec.id != values.id) {
            //             return rec;
            //         } else {
            //             return { ...rec, ...res.data.data };
            //         }
            //     }),
            // }));
            getTableData(1);
            setEditData();
            resetForm();
            setShow(true);
            setMsg(data.message);
            setSubmitting(false);
        } catch (error) {
            setSubmitting(false);
            setShow(true);
            setMsg(error.response.data.message);
        }
    }
    async function addData(values, setSubmitting, resetForm) {
        try {
            if (values.pdfUrl instanceof File) {
                values.pdfUrl = await uploadFileToS3UsingSignedURL(values.pdfUrl, "menuPagesPDFs");
            }
            await API.post("/committees", values);
            // let data = res.data?.data;
            // data.status = 1
            // setList((pre) => ({
            //     ...pre,
            //     data: [...pre.data, data],
            // }));
            getTableData(1);
            // resetForm();
            setSubmitting(false);
        } catch (error) {
            resetForm();
            setSubmitting(false);
            setShow(true);
            setMsg(error.response.data.message);
        }
    }

    async function updateStatus(id, status) {
        await API.post("/committees/disable", { id: id, status: status })
            .then((res) => {
                if (res.data.status === "success") {
                    setList((pre) => ({
                        ...pre,
                        data: pre.data.map((rec) => {
                            if (rec.id != id) {
                                return rec;
                            } else {
                                return { ...rec, status: parseInt(rec.status) ? 0 : 1 };
                            }
                        }),
                    }));
                    setShow(true);
                    setMsg(res.data.message);
                }
            })
            .catch((error) => {
                setShow(true);
                setMsg(error.response.data.message);
            });
    }
};

export default Committees;
